/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addNewPostToNewsFeed } from '../fn/news-feed/add-new-post-to-news-feed';
import { AddNewPostToNewsFeed$Params } from '../fn/news-feed/add-new-post-to-news-feed';
import { addNewsFeedActivityToNewsFeed } from '../fn/news-feed/add-news-feed-activity-to-news-feed';
import { AddNewsFeedActivityToNewsFeed$Params } from '../fn/news-feed/add-news-feed-activity-to-news-feed';
import { BooleanResponse } from '../models/boolean-response';
import { deleteNewsFeedItem } from '../fn/news-feed/delete-news-feed-item';
import { DeleteNewsFeedItem$Params } from '../fn/news-feed/delete-news-feed-item';
import { getNewsFeed } from '../fn/news-feed/get-news-feed';
import { GetNewsFeed$Params } from '../fn/news-feed/get-news-feed';
import { getNewsFeedForProfile } from '../fn/news-feed/get-news-feed-for-profile';
import { GetNewsFeedForProfile$Params } from '../fn/news-feed/get-news-feed-for-profile';
import { NewsFeedListForUserResponse } from '../models/news-feed-list-for-user-response';
import { NewsFeedListResponse } from '../models/news-feed-list-response';
import { newsFeedWellDone } from '../fn/news-feed/news-feed-well-done';
import { NewsFeedWellDone$Params } from '../fn/news-feed/news-feed-well-done';
import { reportNewsFeedPost } from '../fn/news-feed/report-news-feed-post';
import { ReportNewsFeedPost$Params } from '../fn/news-feed/report-news-feed-post';
import { sendEmail } from '../fn/news-feed/send-email';
import { SendEmail$Params } from '../fn/news-feed/send-email';
import { updateNewsFeedPost } from '../fn/news-feed/update-news-feed-post';
import { UpdateNewsFeedPost$Params } from '../fn/news-feed/update-news-feed-post';
import { WellDoneResponse } from '../models/well-done-response';

@Injectable({ providedIn: 'root' })
export class NewsFeedService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addNewPostToNewsFeed()` */
  static readonly AddNewPostToNewsFeedPath = '/rest/newsfeed/post';

  /**
   * Create new newsfeed item of type post.
   *
   * Newsfeed item (type - post), when created, will be added to user who created newsfeed item and to all users who are following this user. If newsfeed item is 'for-all', all users of smarthead will have this newsfeed item in their newsfeed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addNewPostToNewsFeed()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addNewPostToNewsFeed$Response(params: AddNewPostToNewsFeed$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedListResponse>> {
    return addNewPostToNewsFeed(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new newsfeed item of type post.
   *
   * Newsfeed item (type - post), when created, will be added to user who created newsfeed item and to all users who are following this user. If newsfeed item is 'for-all', all users of smarthead will have this newsfeed item in their newsfeed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addNewPostToNewsFeed$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addNewPostToNewsFeed(params: AddNewPostToNewsFeed$Params, context?: HttpContext): Observable<NewsFeedListResponse> {
    return this.addNewPostToNewsFeed$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewsFeedListResponse>): NewsFeedListResponse => r.body)
    );
  }

  /** Path part for operation `addNewsFeedActivityToNewsFeed()` */
  static readonly AddNewsFeedActivityToNewsFeedPath = '/rest/newsfeed/activity';

  /**
   * Create new newsfeed item of type activity.
   *
   * Newsfeed item (type - actvity), when created, will be added to user who created newsfeed item and to all users who are following this user. If newsfeed item is 'for-all', all users of smarthead will have this newsfeed item in their newsfeed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addNewsFeedActivityToNewsFeed()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addNewsFeedActivityToNewsFeed$Response(params: AddNewsFeedActivityToNewsFeed$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedListResponse>> {
    return addNewsFeedActivityToNewsFeed(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new newsfeed item of type activity.
   *
   * Newsfeed item (type - actvity), when created, will be added to user who created newsfeed item and to all users who are following this user. If newsfeed item is 'for-all', all users of smarthead will have this newsfeed item in their newsfeed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addNewsFeedActivityToNewsFeed$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addNewsFeedActivityToNewsFeed(params: AddNewsFeedActivityToNewsFeed$Params, context?: HttpContext): Observable<NewsFeedListResponse> {
    return this.addNewsFeedActivityToNewsFeed$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewsFeedListResponse>): NewsFeedListResponse => r.body)
    );
  }

  /** Path part for operation `getNewsFeed()` */
  static readonly GetNewsFeedPath = '/rest/newsfeed/{offset}/{limit}';

  /**
   * Get list of newsfeeds for user in token. Required is from/limit -> pagging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNewsFeed()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNewsFeed$Response(params: GetNewsFeed$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedListForUserResponse>> {
    return getNewsFeed(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of newsfeeds for user in token. Required is from/limit -> pagging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNewsFeed$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNewsFeed(params: GetNewsFeed$Params, context?: HttpContext): Observable<NewsFeedListForUserResponse> {
    return this.getNewsFeed$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewsFeedListForUserResponse>): NewsFeedListForUserResponse => r.body)
    );
  }

  /** Path part for operation `getNewsFeedForProfile()` */
  static readonly GetNewsFeedForProfilePath = '/rest/newsfeed/profile/{id}/{page}/{limit}';

  /**
   * Get list of newsfeeds for profile. Required is from/limit -> pagging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNewsFeedForProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNewsFeedForProfile$Response(params: GetNewsFeedForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedListResponse>> {
    return getNewsFeedForProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of newsfeeds for profile. Required is from/limit -> pagging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNewsFeedForProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNewsFeedForProfile(params: GetNewsFeedForProfile$Params, context?: HttpContext): Observable<NewsFeedListResponse> {
    return this.getNewsFeedForProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewsFeedListResponse>): NewsFeedListResponse => r.body)
    );
  }

  /** Path part for operation `updateNewsFeedPost()` */
  static readonly UpdateNewsFeedPostPath = '/rest/newsfeed/{id}';

  /**
   * Update existing newsfeed item of type post. 1) URL is set -> set url and remove old photo if exists 2) new photo is set (photo parameter in request is size bigger than 0) > clear url, remove old photo if exists and upload new 3) photo parameter is present but length is equal to 0 > clear url and remove old photo if exists 4) no url / photo parameter is present > clear url and remove old photo if exists.
   *
   * Newsfeed item (type - post) will be updated.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateNewsFeedPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNewsFeedPost$Response(params: UpdateNewsFeedPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedListResponse>> {
    return updateNewsFeedPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing newsfeed item of type post. 1) URL is set -> set url and remove old photo if exists 2) new photo is set (photo parameter in request is size bigger than 0) > clear url, remove old photo if exists and upload new 3) photo parameter is present but length is equal to 0 > clear url and remove old photo if exists 4) no url / photo parameter is present > clear url and remove old photo if exists.
   *
   * Newsfeed item (type - post) will be updated.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateNewsFeedPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNewsFeedPost(params: UpdateNewsFeedPost$Params, context?: HttpContext): Observable<NewsFeedListResponse> {
    return this.updateNewsFeedPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewsFeedListResponse>): NewsFeedListResponse => r.body)
    );
  }

  /** Path part for operation `deleteNewsFeedItem()` */
  static readonly DeleteNewsFeedItemPath = '/rest/newsfeed/{id}';

  /**
   * Delete NewsFeed item. Deleted can be only item which user created (SH Admin can delete all).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteNewsFeedItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteNewsFeedItem$Response(params: DeleteNewsFeedItem$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return deleteNewsFeedItem(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete NewsFeed item. Deleted can be only item which user created (SH Admin can delete all).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteNewsFeedItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteNewsFeedItem(params: DeleteNewsFeedItem$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.deleteNewsFeedItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

  /** Path part for operation `reportNewsFeedPost()` */
  static readonly ReportNewsFeedPostPath = '/rest/newsfeed/{id}/report';

  /**
   * Report NewsFeed post, send email warning to SmartHead administrators.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportNewsFeedPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportNewsFeedPost$Response(params: ReportNewsFeedPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return reportNewsFeedPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Report NewsFeed post, send email warning to SmartHead administrators.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportNewsFeedPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportNewsFeedPost(params: ReportNewsFeedPost$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.reportNewsFeedPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

  /** Path part for operation `sendEmail()` */
  static readonly SendEmailPath = '/rest/newsfeed/{id}/email';

  /**
   * Send email (newsletter) about NewsFeed post to all users who have not turned of notifications.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendEmail$Response(params: SendEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return sendEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Send email (newsletter) about NewsFeed post to all users who have not turned of notifications.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendEmail(params: SendEmail$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.sendEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

  /** Path part for operation `newsFeedWellDone()` */
  static readonly NewsFeedWellDonePath = '/rest/newsfeed/{id}/well-done';

  /**
   * User must be logged to call this service. Logged user will clap with hands - add well done to NewsFeed. There is maximum of well done which user can give to NewsFeed. After that count is not anymore increased.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsFeedWellDone()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsFeedWellDone$Response(params: NewsFeedWellDone$Params, context?: HttpContext): Observable<StrictHttpResponse<WellDoneResponse>> {
    return newsFeedWellDone(this.http, this.rootUrl, params, context);
  }

  /**
   * User must be logged to call this service. Logged user will clap with hands - add well done to NewsFeed. There is maximum of well done which user can give to NewsFeed. After that count is not anymore increased.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsFeedWellDone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsFeedWellDone(params: NewsFeedWellDone$Params, context?: HttpContext): Observable<WellDoneResponse> {
    return this.newsFeedWellDone$Response(params, context).pipe(
      map((r: StrictHttpResponse<WellDoneResponse>): WellDoneResponse => r.body)
    );
  }

}
